import parseCAPIMessage from "@tvg/utils/capiUtils";
import { CapiMessageContent } from "../types";
import { defaultMessage } from "./defaultValues";

export const getCapiMessageContent = (store: unknown): CapiMessageContent =>
  parseCAPIMessage(store, "capi.messages.topPoolsContent", defaultMessage);
